// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host /deep/ .accordion .card:last-of-type{
    background: #fff;
    border: #D3D3D3 solid 1px;
    display: block;
    margin-bottom: 1.5rem !important;
}

:host /deep/ .accordion:last-child .card{margin-bottom:0 !important;}

:host /deep/ .card-header{
    background-color: #fff !important;
    border: none !important;
    padding: 17px 18px;
}

:host /deep/ .card-header h5{
    border: none;
    line-height: 15px;
}

:host /deep/ .card-header .btn-link{
    padding: 0px;
    font-size: 19px;
    line-height: 19px;
    font-weight: bold;
    color: #4D4F5C;
    text-decoration: none;
}

:host /deep/ .card-header .btn-link:after{
    transform: rotate(90deg);
    content: "";
    background: url(/assets/images/panel-arrow.svg) no-repeat center center;
    top: 5px;
    position: absolute;
    width: 20px;
    height: 19px;
    transition: all 0.5s ease;
    display: inline-block;
	right:-33px;
}

:host /deep/ .card-header .btn-link.collapsed:after{
    content: "";
    background: url(/assets/images/panel-arrow.svg) no-repeat center right;
    top: 5px;
    position: absolute;
    width: 20px;
    height: 19px;
    transition: all 0.5s ease;
    display: inline-block;
    transform: rotate(0deg);
}

:host /deep/ .collapse.show{
    transition: all 0.5s ease;
}

:host /deep/ .card-body{
    padding: 0 18px 17px;
}
:host /deep/ .card-body h2{
    font-size: 19px;
    font-weight: 700;
    margin-bottom: 20px;
}

:host /deep/ .ss_val{
    width: 50px;
    height: 24px;
    border: 1px solid #bbb;
    position: relative;
    opacity: 1;
}

.indicator.circle{
    background: #3597EC url(/assets/images/ellipses-icon.svg) no-repeat center;
    background-size: 50%;
}

:host /deep/ .btn.collapsed .indicator.circle{
    background: #ECECEC;
    width: 22px;
    height: 22px;
    border-radius: 22px;
    vertical-align: middle;
    display: inline-block;
    margin: 0 10px 0 0;
}

.indicator.circle.completed{
    /* background: #00A89B url(/assets/images/tick-mark-icon.svg) no-repeat center;
    background-size: 50%; */
    background: #00A89B url(/assets/images/tick-white-mark-icon.svg) no-repeat center;
    background-size: 50%;
}


:host /deep/ .content-editor{margin-bottom:18px;}

::ng-deep .ck-editor__editable {
    min-height: 300px; /* Set your desired minimum height here */
}`, "",{"version":3,"sources":["webpack://./src/app/components/customer/intakes/add-intakes-data/basic/content/homepage/homepage.component.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;IACd,gCAAgC;AACpC;;AAEA,yCAAyC,0BAA0B,CAAC;;AAEpE;IACI,iCAAiC;IACjC,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;IACxB,WAAW;IACX,uEAAuE;IACvE,QAAQ;IACR,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,qBAAqB;CACxB,WAAW;AACZ;;AAEA;IACI,WAAW;IACX,sEAAsE;IACtE,QAAQ;IACR,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;AACxB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,0EAA0E;IAC1E,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI;2BACuB;IACvB,iFAAiF;IACjF,oBAAoB;AACxB;;;AAGA,6BAA6B,kBAAkB,CAAC;;AAEhD;IACI,iBAAiB,EAAE,yCAAyC;AAChE","sourcesContent":[":host /deep/ .accordion .card:last-of-type{\n    background: #fff;\n    border: #D3D3D3 solid 1px;\n    display: block;\n    margin-bottom: 1.5rem !important;\n}\n\n:host /deep/ .accordion:last-child .card{margin-bottom:0 !important;}\n\n:host /deep/ .card-header{\n    background-color: #fff !important;\n    border: none !important;\n    padding: 17px 18px;\n}\n\n:host /deep/ .card-header h5{\n    border: none;\n    line-height: 15px;\n}\n\n:host /deep/ .card-header .btn-link{\n    padding: 0px;\n    font-size: 19px;\n    line-height: 19px;\n    font-weight: bold;\n    color: #4D4F5C;\n    text-decoration: none;\n}\n\n:host /deep/ .card-header .btn-link:after{\n    transform: rotate(90deg);\n    content: \"\";\n    background: url(/assets/images/panel-arrow.svg) no-repeat center center;\n    top: 5px;\n    position: absolute;\n    width: 20px;\n    height: 19px;\n    transition: all 0.5s ease;\n    display: inline-block;\n\tright:-33px;\n}\n\n:host /deep/ .card-header .btn-link.collapsed:after{\n    content: \"\";\n    background: url(/assets/images/panel-arrow.svg) no-repeat center right;\n    top: 5px;\n    position: absolute;\n    width: 20px;\n    height: 19px;\n    transition: all 0.5s ease;\n    display: inline-block;\n    transform: rotate(0deg);\n}\n\n:host /deep/ .collapse.show{\n    transition: all 0.5s ease;\n}\n\n:host /deep/ .card-body{\n    padding: 0 18px 17px;\n}\n:host /deep/ .card-body h2{\n    font-size: 19px;\n    font-weight: 700;\n    margin-bottom: 20px;\n}\n\n:host /deep/ .ss_val{\n    width: 50px;\n    height: 24px;\n    border: 1px solid #bbb;\n    position: relative;\n    opacity: 1;\n}\n\n.indicator.circle{\n    background: #3597EC url(/assets/images/ellipses-icon.svg) no-repeat center;\n    background-size: 50%;\n}\n\n:host /deep/ .btn.collapsed .indicator.circle{\n    background: #ECECEC;\n    width: 22px;\n    height: 22px;\n    border-radius: 22px;\n    vertical-align: middle;\n    display: inline-block;\n    margin: 0 10px 0 0;\n}\n\n.indicator.circle.completed{\n    /* background: #00A89B url(/assets/images/tick-mark-icon.svg) no-repeat center;\n    background-size: 50%; */\n    background: #00A89B url(/assets/images/tick-white-mark-icon.svg) no-repeat center;\n    background-size: 50%;\n}\n\n\n:host /deep/ .content-editor{margin-bottom:18px;}\n\n::ng-deep .ck-editor__editable {\n    min-height: 300px; /* Set your desired minimum height here */\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
